import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { VisualLanguagePopup } from './VisualLanguagePopup';

const POPUP_KEY = Symbol('VISUAL_LANGUAGE');

export const useVisualLanguagePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, VisualLanguagePopup);
  });

  return useCallback(
    ({ visualLanguage = null, noRedirect = false } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          visualLanguage,
          noRedirect,

          onClose: (result) => {
            popups.closePopup(POPUP_KEY);
            if (result?.id) {
              resolve(result);
            } else {
              resolve(null);
            }
          },
        });
      });
    },
    [popups]
  );
};
